import { SwayyRoute } from "./views/components/AppContent";
import SwayyDashboard from "./views/pages/SwayyDashboard";
import SwayyCategories from "./views/pages/catalog/SwayyCategories";
import SwayyCategoryDetail from "./views/pages/catalog/SwayyCategoryDetail";
import SwayyCatalogOptionDetail from "./views/pages/catalog/SwayyCatalogOptionDetail";
import SwayyCatalogOptions from "./views/pages/catalog/SwayyCatalogOptions";
import SwayyPriceLists from "./views/pages/catalog/SwayyPriceLists";
import SwayyProductDetail from "./views/pages/products/SwayyProductDetail";
import SwayyProducts from "./views/pages/products/SwayyProducts";
import SwayyOrders from "./views/pages/orders/SwayyOrders";
import SwayyOrderDetail from "./views/pages/orders/SwayyOrderDetail";
import SwayyShipments from "./views/pages/shipments/SwayyShipments";
import SwayyCoupons from "./views/pages/coupons/SwayyCoupons";
import SwayyInvoices from "./views/pages/invoices/SwayyInvoices";

const routes: SwayyRoute[] = [
  { path: "", exact: true, element: SwayyDashboard },
  { path: "/products", exact: true, element: SwayyProducts },
  { path: "/products/:id", element: SwayyProductDetail },
  { path: "/catalog-options", exact: true, element: SwayyCatalogOptions },
  { path: "/catalog-options/:id", exact: true, element: SwayyCatalogOptionDetail },
  { path: "/categories", exact: true, element: SwayyCategories },
  { path: "/categories/:id", exact: true, element: SwayyCategoryDetail },
  { path: "/price-lists", exact: true, element: SwayyPriceLists },
  { path: "/orders/listing", exact: true, element: SwayyOrders },
  { path: "/orders/:id", exact: true, element: SwayyOrderDetail },
  { path: "/shipments", exact: true, element: SwayyShipments },
  { path: "/coupons", exact: true, element: SwayyCoupons },
  { path: "/invoices", exact: true, element: SwayyInvoices },
];

export default routes;
